import USER_TYPES from './types';
import { type IUser, type IMetadata, type IUserType } from 'src/models';

function initialState() {
	return {
		type: USER_TYPES.INITIAL_STATE,
	};
}

function getAll(type: IUserType, page?: number, pageSize?: number) {
	return {
		type: USER_TYPES.GET_ALL,
		payload: { type, page, pageSize },
	};
}

function getByInstitution(
	institutionId: number,
	type: IUserType,
	page?: number,
	pageSize?: number,
) {
	return {
		type: USER_TYPES.GET_BY_INSTITUTION,
		payload: { institutionId, type, page, pageSize },
	};
}

function getAllByInstitution(institutionId: number) {
	return {
		type: USER_TYPES.GET_ALL_BY_INSTITUTION,
		payload: { institutionId },
	};
}

function setAllByInstitution(data: IUser[]) {
	return {
		type: USER_TYPES.SET_ALL_BY_INSTITUTION,
		payload: { data },
	};
}

function setAll(data: IUser[], metadata?: IMetadata) {
	return {
		type: USER_TYPES.SET_ALL,
		payload: { data, metadata },
	};
}

function getOne(id: string) {
	return {
		type: USER_TYPES.GET_ONE,
		payload: { id },
	};
}

function setOne(user: IUser) {
	return {
		type: USER_TYPES.SET_ONE,
		payload: { user },
	};
}

function create(user: IUser) {
	return {
		type: USER_TYPES.CREATE,
		payload: { user },
	};
}

function update(user: IUser) {
	return {
		type: USER_TYPES.UPDATE,
		payload: { user },
	};
}

function remove(id: string) {
	return {
		type: USER_TYPES.REMOVE,
		payload: { id },
	};
}

function set(type: string, value: any) {
	return {
		type: USER_TYPES.SET,
		payload: { type, value },
	};
}

function bulkUpload(formData: FormData) {
	return {
		type: USER_TYPES.BULK_UPLOAD,
		payload: { formData },
	};
}

function downloadLayout() {
	return {
		type: USER_TYPES.DOWNLOAD_LAYOUT,
	};
}

function setBulkUploadSummary(data: any) {
	return {
		type: USER_TYPES.SET_BULK_UPLOAD_SUMMARY,
		payload: { data },
	};
}

function getCertificates(
	institutionId: number,
	courseId: number,
	year: number,
	page?: number,
	pageSize?: number,
) {
	return {
		type: USER_TYPES.GET_CERTIFICATES,
		payload: { institutionId, courseId, year, page, pageSize },
	};
}

function setCertificates(data: any[], metadata?: IMetadata) {
	return {
		type: USER_TYPES.SET_CERTIFICATES,
		payload: { data, metadata },
	};
}

function downloadCertificates({
	institutionId,
	courseId,
	year,
	institutionName,
}: {
	institutionId: number,
	courseId: number,
	year: number,
	institutionName: string,
}) {
	return {
		type: USER_TYPES.DOWNLOAD_CERTIFICATES,
		payload: { institutionId, courseId, year, institutionName },
	};
}

const userActions = {
	initialState,
	getAll,
	getByInstitution,
	getAllByInstitution,
	setAllByInstitution,
	setAll,
	getOne,
	setOne,
	create,
	update,
	remove,
	set,
	bulkUpload,
	downloadLayout,
	setBulkUploadSummary,
	getCertificates,
	setCertificates,
	downloadCertificates
};

export default userActions;
